import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import simsSummary from "../../assets/img/docs/sims-summary.png"; // ⬅️ replace with your screenshot path
import simsTable from "../../assets/img/docs/sims-table.png"; // ⬅️ replace with your screenshot path

const SimsPanel = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className="py-5 sims-panel">
      {/* ✅ Intro */}
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              <Card.Title className="display-6 mb-3">
                {t("documentation.simCards.panel.title")}
              </Card.Title>
              <Card.Text>{t("documentation.simCards.panel.intro")}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* ✅ Summary Cards + Filters */}
      <Row>
        <Col lg={10} className="mx-auto">
          <Card className="shadow-sm border-0 rounded-lg p-4 mb-4">
            <Card.Body>
              <Row className="align-items-center">
                <Col md={6}>
                  <Card.Subtitle className="h6 mb-3">
                    {t("documentation.simCards.panel.summary.title")}
                  </Card.Subtitle>
                  <Card.Text>
                    {t("documentation.simCards.panel.summary.intro")}
                  </Card.Text>
                  <ul>
                    <li>
                      {t("documentation.simCards.panel.summary.dataVolume")}
                    </li>
                    <li>
                      {t("documentation.simCards.panel.summary.dataSessions")}
                    </li>
                    <li>
                      {t("documentation.simCards.panel.summary.zeroSessions")}
                    </li>
                  </ul>
                  <Card.Text>
                    {t("documentation.simCards.panel.summary.filters")}
                  </Card.Text>
                </Col>
                <Col md={6}>
                  <Image
                    src={simsSummary}
                    alt="SIMs summary cards and filters"
                    className="doc-image"
                    fluid
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* ✅ SIM Table */}
      <Row>
        <Col lg={10} className="mx-auto">
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              <Row className="align-items-center">
                <Col md={6}>
                  <Card.Subtitle className="h6 mb-3">
                    {t("documentation.simCards.panel.table.title")}
                  </Card.Subtitle>
                  <Card.Text>
                    {t("documentation.simCards.panel.table.intro")}
                  </Card.Text>
                  <ul>
                    <li>
                      {t("documentation.simCards.panel.table.activeSession")}
                    </li>
                    <li>
                      {t("documentation.simCards.panel.table.identifiers")}
                    </li>
                    <li>{t("documentation.simCards.panel.table.state")}</li>
                    <li>{t("documentation.simCards.panel.table.offer")}</li>
                    <li>{t("documentation.simCards.panel.table.data")}</li>
                    <li>{t("documentation.simCards.panel.table.type")}</li>
                  </ul>
                  <Card.Text>
                    {t("documentation.simCards.panel.table.footer")}
                  </Card.Text>
                </Col>
                <Col md={6}>
                  <Image
                    src={simsTable}
                    alt="SIMs table with details"
                    className="doc-image"
                    fluid
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SimsPanel;
